/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Dialog_DescriptionInputs */

const en_branches_dialog_description = /** @type {(inputs: Branches_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branches share this client's contract and fees, but can have their own contacts and address.`)
};

const pt_br2_branches_dialog_description = /** @type {(inputs: Branches_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As filiais compartilham o contrato e as taxas deste cliente, mas podem ter contatos e endereço próprios.`)
};

/**
* | output |
* | --- |
* | "Branches share this client's contract and fees, but can have their own contacts and address." |
*
* @param {Branches_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_dialog_description = /** @type {((inputs?: Branches_Dialog_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Dialog_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_dialog_description(inputs)
	return pt_br2_branches_dialog_description(inputs)
});